// The qualifying questions, in the browser.
//
// The scoring lives on the server (server/agents/qualify.js) and is the only
// thing that decides a band — a score the browser could set would be a score
// that means nothing. This is the WORDS, so the sheet can read them down a
// phone, and the two lists are checked against each other by
// server/agents/qualifyWords.test.js so they cannot drift apart.
export const QUALIFY_QUESTIONS = [
  {
    key: 'reachable',
    label: 'A way to reach them',
    ask: 'What is the best number to reach you on, and is a text alright?',
    why: 'Nothing else on this list matters if the call does not connect.',
  },
  {
    key: 'scope',
    label: 'What the work is',
    ask: 'Tell me what you are looking to have done, and roughly how big it is.',
    why: 'A price cannot be put on "some work at my house".',
  },
  {
    key: 'owner',
    label: 'Whether they can say yes',
    ask: 'Are you the owner of the property, or are you asking on behalf of somebody?',
    why: 'A quote given to somebody who has to ask their landlord is a quote that waits.',
  },
  {
    key: 'timing',
    label: 'When they want it done',
    ask: 'When are you hoping to have this done by?',
    why: 'A date is the difference between a lead and a job. "Sometime" is a no.',
  },
  {
    key: 'budget',
    label: 'What they expect to spend',
    ask: 'Do you have a figure in mind for this, so I know we are in the same ballpark?',
    why: 'Pricing a job for somebody expecting a third of it wastes both mornings.',
  },
  {
    key: 'competition',
    label: 'Who else they are talking to',
    ask: 'Have you had anybody else out to look at it yet?',
    why: 'Third bid in means price shopping. First in means the job is yours to lose.',
  },
];
